module.exports = "\r\n<ion-button color=\"purple\" (click)=\"checkIfUserCanCreateProject()\" class=\"new-project-button\">+</ion-button>\r\n"